















































import {
  apiMerchantStoreGetStoreIntroduction,
  apiShoppingCartQuantity,
} from '@/api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { navigateTo } from '@/router'
import { onMounted, onUpdated, ref } from '@vue/composition-api'
import { submit } from '@/utils'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        onMounted(() => {
          this.updateHeight()
          this.getCartCount()
        })

        onUpdated(() => {
          this.updateHeight()
        })
      }

      // 商品数据
      goodsData = goodsProvider.inject()

      // 购物车商品数量
      cartCount = ref(0)

      // 操作栏高度
      height = ref(0)

      // 更新高度
      updateHeight = () => {
        this.height.value =
          (document.querySelector(`.${ctx._.actions}`)?.clientHeight || 0) +
          (document.querySelector(`.${ctx._.tips}`)?.clientHeight || 0)
      }

      // 获取购物车数量
      getCartCount = async () => {
        const { quantity } = await apiShoppingCartQuantity()
        this.cartCount.value = quantity
      }

      // 点击首页
      handleHomeClick = () => {
        navigateTo('HomeIndex')
      }

      // 点击客服
      handleContactClick = () => {
        submit(async $ => {
          $.start()
          const martData = await apiMerchantStoreGetStoreIntroduction({
            storeId: this.goodsData.value.merchantId,
          })
          dcb.makePhoneCall({
            phoneNumber: martData.storePhone!,
          })
        })
      }

      // 点击店铺
      handleMartClick = () => {
        navigateTo('MartIndex', {
          id: this.goodsData.value.merchantId,
        })
      }

      // 点击购物车
      handleCartClick = () => {
        navigateTo('CartIndex')
      }

      // 点击加入购物车
      handleAddCartClick = () => {
        this.goodsData.value.showSkuPicker({
          action: 'addCart',
          callback: () => this.getCartCount(),
        })
      }

      // 点击购买
      handleBuyClick = () => {
        this.goodsData.value.showSkuPicker({
          action: 'buy',
        })
      }

      // 点击秒杀
      handleSeckillClick = () => {
        this.goodsData.value.showSkuPicker({
          action: 'buy',
        })
      }

      // 点击发起拼团
      handleGroupBuyClick = () => {
        this.goodsData.value.showSkuPicker({
          action: 'groupBuying',
        })
      }
    },
)
